<template>
  <el-form
    label-width="100px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="电话" required>
      <el-input v-model="form.phone" clearable />
    </el-form-item>

    <el-form-item label="数额" required>
      <el-input v-model="form.amount" clearable />
    </el-form-item>
    <el-form-item label="最小使用金额" required>
      <el-input v-model="form.allow" clearable />
    </el-form-item>
    <el-form-item
        label="状态"
        prop="status"
      >
        <el-select v-model="form.status" placeholder="状态" clearable>
          <el-option
            v-for="item in couponStatusEnums"
            :label="item.label"
            :key="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    <el-form-item label="过期时间" required>
      <el-date-picker
        v-model="form.expire_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="过期时间"
        style="width: 100%"
      />
    </el-form-item>
   
  </el-form>
</template>

<script setup>
import { couponStatusEnums } from "@/config/enums";
import { htmlDecodeByRegExp } from '@/utils/utils'
import { onBeforeUnmount, nextTick, ref, shallowRef, onMounted, getCurrentInstance } from "vue";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  phone: "",
  amount: "",
  allow: "",
  status: "",
  expire_time: "",
});
const props = defineProps(["item"]);

// const headers = ref({})
onMounted(() => {
  // headers.value['Accept-Token'] = getTokenAUTH()
  nextTick(() => {
    // props.item.content = htmlDecodeByRegExp(props.item.content)
    form.value = Object.assign(form.value, props.item);
  });
});

const { proxy } = getCurrentInstance()

// const typesEnum = ref([])


// const successUpload = (res) => {
//   form.value.img = res.data.url;
// };

// const handleErr = (err) => {
//   if (err.status == 320) {
//     form.value.img = JSON.parse(err.message).data.url;
//   }
// }

// // 编辑器实例，必须用 shallowRef
// const editorRef = shallowRef();

// // 内容 HTML
// const valueHtml = ref("<p>hello</p>");
// const mode = ref("default");

// const toolbarConfig = {};
// const editorConfig =  {
//   placeholder: "请输入内容...",
//   MENU_CONF: {
//     uploadImage: {
//       fieldName: "file",
//       maxFileSize: 10 * 1024 * 1024, // 10M
//       server: proxy.BASE_API_URL + "index/uploadX",
//       headers: {
//         "Accept-Token": getTokenAUTH(),
//       },
//       customInsert(res, insertFn) {
//         const url = proxy.IMG_BASE_URL + res.data.url;
//         const alt = res.data.alt
//         const href = res.data.href
//         insertFn(url, alt, href);
//       },
//     },
//   },
// };

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  // const editor = editorRef.value;
  // if (editor == null) return;
  // editor.destroy();
});

const handleCreated = (editor) => {
  // editorRef.value = editor; // 记录 editor 实例，重要！
};

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}

/deep/ .el-radio-group {
  width: 220px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
